import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Modal, Tooltip, OverlayTrigger } from 'react-bootstrap';
import QcReportDetails from './qcReportDetails';
import Swal from 'sweetalert2';
import { FullscreenModal, ModalStyled } from '../../../../theme/customizedStyleComponents';
import { deleteQcReport } from '../../../../services/clinicPortalServices/qcReportService';
import { trackRecentView } from '../../../../services/clinicPortalServices/recentViewService';

const panelStyles = {
    overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.3)', zIndex: 1040 },
    panel: { position: 'fixed', top: 0, right: 0, width: '420px', height: '100vh', background: '#fff', boxShadow: '-4px 0 20px rgba(0,0,0,0.15)', zIndex: 1041, display: 'flex', flexDirection: 'column', overflowY: 'auto' },
    header: { padding: '16px 20px', borderBottom: '1px solid #e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#f8f9fa' },
    title: { margin: 0, fontSize: '16px', fontWeight: 600, color: '#333' },
    body: { padding: '20px', flex: 1 },
    section: { marginBottom: '20px' },
    sectionTitle: { fontSize: '11px', fontWeight: 700, color: '#888', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '10px', paddingBottom: '6px', borderBottom: '1px solid #eee' },
    dl: { display: 'grid', gridTemplateColumns: '140px 1fr', rowGap: '8px', margin: 0 },
    dt: { fontSize: '13px', color: '#555', fontWeight: 600, paddingRight: '8px' },
    dd: { fontSize: '13px', color: '#222', margin: 0 },
    viewBtn: { background: '#0066cc', color: '#fff', border: 'none', borderRadius: '4px', padding: '6px 14px', fontSize: '13px', cursor: 'pointer', marginRight: '8px' },
    closeBtn: { background: 'transparent', border: 'none', fontSize: '18px', cursor: 'pointer', color: '#666' }
};

export default class EditBtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            showPanel: false,
            qcReportId: props.data._id
        };
    }

    handleDelete = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this report!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it',
            customClass: {
                container: window.localStorage.getItem('appTheme') === 'Dark' && /clinic|lims/.test(window.location.pathname.split('/')[1]) && 'dark-swal',
                cancelButton: 'order-1',
                confirmButton: 'order-2'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                deleteQcReport({ _id: this.state.qcReportId, name: this.props.data.name }).then(() => {
                    this.props.context.componentParent.loadGridData();
                });
            }
        });
    };

    handleShow = () => {
        this.setState({ show: true });
        const qcReport = this.props.data;
        if (qcReport) {
            trackRecentView('qc_report', qcReport._id, qcReport.name || 'QC Report', '/clinic/qc_reports');
        }
    };

    handleClose = () => {
        this.setState({ show: false });
        this.props.context.componentParent.loadGridData();
    };

    renderPanel() {
        const d = this.props.data;
        return ReactDOM.createPortal(
            <>
                <div style={panelStyles.overlay} onClick={() => this.setState({ showPanel: false })} />
                <div style={panelStyles.panel}>
                    <div style={panelStyles.header}>
                        <h5 style={panelStyles.title}>QC Report Details</h5>
                        <div>
                            <button style={panelStyles.viewBtn} onClick={() => { this.setState({ showPanel: false }); this.handleShow(); }}>
                                <i className="fas fa-expand" style={{ marginRight: 5 }}></i>Full Report
                            </button>
                            <button style={panelStyles.closeBtn} onClick={() => this.setState({ showPanel: false })}>
                                <i className="fas fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div style={panelStyles.body}>
                        <div style={panelStyles.section}>
                            <div style={panelStyles.sectionTitle}>Report Information</div>
                            <dl style={panelStyles.dl}>
                                <dt style={panelStyles.dt}>Analyte</dt>
                                <dd style={panelStyles.dd}>{d.analyte || d.analyteId?.name || '—'}</dd>
                                <dt style={panelStyles.dt}>Control Type</dt>
                                <dd style={panelStyles.dd}>{d.controlType || '—'}</dd>
                                <dt style={panelStyles.dt}>Lot Number</dt>
                                <dd style={panelStyles.dd}>{d.lotNumber || '—'}</dd>
                                <dt style={panelStyles.dt}>QC Sample ID</dt>
                                <dd style={panelStyles.dd}>{d.qcSample || '—'}</dd>
                                <dt style={panelStyles.dt}>Sample Status</dt>
                                <dd style={panelStyles.dd}>{d.sampleStatus || '—'}</dd>
                                <dt style={panelStyles.dt}>Result Status</dt>
                                <dd style={panelStyles.dd}>{d.resultStatus || '—'}</dd>
                                <dt style={panelStyles.dt}>Instrument</dt>
                                <dd style={panelStyles.dd}>{d.instrument || '—'}</dd>
                                <dt style={panelStyles.dt}>Date Range</dt>
                                <dd style={panelStyles.dd}>{d.dateRange || '—'}</dd>
                                <dt style={panelStyles.dt}>Display Mode</dt>
                                <dd style={panelStyles.dd}>{d.displayMode || '—'}</dd>
                                <dt style={panelStyles.dt}>View Mode</dt>
                                <dd style={panelStyles.dd}>{d.viewMode || '—'}</dd>
                            </dl>
                        </div>
                    </div>
                </div>
            </>,
            document.body
        );
    }

    render() {
        return (
            <div>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={<Tooltip id="button-tooltip">View QC Report</Tooltip>}>
                    <button onClick={() => this.setState({ showPanel: true })} className="edit-order-btn">
                        <i className="fas fa-eye"></i>
                    </button>
                </OverlayTrigger>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={<Tooltip id="button-tooltip">Delete QC Report</Tooltip>}>
                    <button onClick={this.handleDelete} className="edit-order-btn">
                        <i className="fas fa-trash"></i>
                    </button>
                </OverlayTrigger>
                {this.state.showPanel && this.renderPanel()}
                <FullscreenModal size="lg" aria-labelledby="contained-modal-title-vcenter" centered show={this.state.show} onHide={this.handleClose} backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title>Quality Control / QC Reports</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <QcReportDetails qcReportId={this.state.qcReportId} context={this.props.context} handleClose={this.handleClose} />
                    </Modal.Body>
                </FullscreenModal>
            </div>
        );
    }
}
